import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import FaqSearchSC, { SearchInputSC } from './faq-search.styled';
import { withRouter } from 'react-router-dom';
import Button from '../ui/button';
import { SmallText } from '../typography';

const _FaqSearch = ({ history, match, mostSearched }) => {
  const uriSearchTerm = match.params.term;
  const [searchTerm, setSearchTerm] = useState(uriSearchTerm);

  useEffect(() => {
    setSearchTerm(uriSearchTerm);
  }, [uriSearchTerm]);

  const handleSearchClick = () => {
    return searchTerm !== '' && searchTerm !== undefined
      ? history.push(`/faq/results/${searchTerm}`)
      : history.push('/faq');
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      return searchTerm !== '' && searchTerm !== undefined
        ? history.push(`/faq/results/${searchTerm}`)
        : history.push('/faq');
    }
  };

  const handleTopSearchClick = (selectedTerm) => {
    return history.push(`/faq/results/${selectedTerm}`);
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <FaqSearchSC>
      <div className="headline-wrap">
        <span>How can we help you?</span>
      </div>
      <div className="search-wrap">
        <SearchInputSC
          placeholder={'Please enter keyword'}
          value={searchTerm}
          onChange={handleSearchInputChange}
          onKeyPress={handleEnterPress}
        />
        <Button type="PRIMARY" size="BIG" onClick={() => handleSearchClick()}>
          Vyhľadávať
        </Button>
      </div>
      <div className="most-searched-wrap">
        <SmallText className="black-transparent">Top search:</SmallText>
        {mostSearched.map((term) => {
          return (
            <Button key={term} type="LINK" onClick={() => handleTopSearchClick(term)}>
              {term}
            </Button>
          );
        })}
      </div>
    </FaqSearchSC>
  );
};

const mapStateToProps = (state) => {
  return {
    mostSearched: state.faq.mostSearched,
  };
};

const FaqSearch = withRouter(connect(mapStateToProps)(_FaqSearch));

export default FaqSearch;
